import { useMemo } from "react";
import { createStore, applyMiddleware } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunkMiddleware from "redux-thunk";
import { fullOrderType, VoucherTypes } from "types";
import moment from "moment";

let store;

const initialState: fullOrderType = {
  dates: [],
  membershipOffer: false,
  donation: 0,
  donationAk: "",
  dndVoucher: "",
  dndVoucherValue: 0,
  dndVoucherType: VoucherTypes.DISCOVER,
  discountSection: false,
  discount: 0,
  discountCode: "",
  fullTimePerfID: "",
  totalTickets: 0,
  totalFee: 0,
  ticketType: "E-Ticket",
  date: "",
  avaTimes: [],
  avaTimeGroups: [],
  upsells: [],
  upsellCode: "",
  eventLists: [],
  contactDetails: {
    title: "",
    first_name: "",
    last_name: "",
    email: "",
    postcode: "",
    mobile_number: "",
    country: "",
    membership_number: "",
    enews: "",
  },
  saleak: "",
  people: [],
  peopleAK: [],
  event: {
    id: "IDHERE",
    name: "",
    date: null,
    time: "",
    perfID: "",
    totalTickets: 0,
    stepOne: "on",
    stepTwo: "off",
    stepThree: "off",
    tickets: [
      {
        id: "",
        ak: "",
        code: "",
        name: "",
        type: "",
        category: "",
        sheetname: "",
        description: "",
        price: 120,
        num: 0,
        details: [],
      },
    ],
  },
  terms: false,
};

const reducer = (state: fullOrderType = initialState, action: any) => {
  switch (action.type) {
    case "UPDATE_TOTAL": {
      state.totalFee = action.val;
      return {
        ...state,
      };
    }
    case "UPDATE_DISCOUNT": {
      state.discount = action.val;
      return {
        ...state,
      };
    }
    case "UPDATE_VOUCHER": {
      state.dndVoucher = action.val.voucherCode;
      state.dndVoucherValue = action.val.balance;
      state.dndVoucherType = action.val.voucherType;
      return {
        ...state,
      };
    }
    case "UPDATE_EVENTID": {
      state.event.id = action.eventID;
      return {
        ...state,
      };
    }
    case "UPDATE_EVENTNAME": {
      state.event.name = action.eventName;
      return {
        ...state,
      };
    }
    case "UPDATE_DISCOUNTBOX": {
      state.discountSection = action.val;
      return {
        ...state,
      };
    }

    case "UPDATE_DONATION": {
      //state.totalFee = state.totalFee - state.donation + action.val;
      state.donation = action.val;
      state.donationAk = action.ak;
      return {
        ...state,
      };
    }

    case "UPDATE_STEPONE": {
      state.event.stepOne = action.val;
      return {
        ...state,
      };
    }
    case "UPDATE_STEPTWO": {
      state.event.stepTwo = action.val;
      return {
        ...state,
      };
    }
    case "UPDATE_STEPTHREE": {
      state.event.stepThree = action.val;
      return {
        ...state,
      };
    }

    case "SET_UPSELL": {
      const upsellID = state.upsells.findIndex((upsell) => {
        return upsell.from === action.from && upsell.to === action.to;
      });
      state.upsells[upsellID].active = state.upsells[upsellID].active === "" ? "on" : "";
      return {
        ...state,
      };
    }

    case "SET_UPSELL_TICKET": {
      const upsellID = state.upsells.findIndex((upsell) => {
        return upsell.from === action.from;
      });
      if (upsellID < 0) {
        return {
          ...state,
        };
      }
      state.upsells[upsellID].upsellTicket = action.upsellTicket;
      return {
        ...state,
      };
    }

    case "UPDATE_FULLTIMEPERF": {
      state.fullTimePerfID = action.perfID;
      return {
        ...state,
      };
    }
    case "UPDATE_AVATIMEGROUPS": {
      state.avaTimeGroups = action.val;
      return {
        ...state,
      };
    }
    case "UPDATE_AVATIMES": {
      state.avaTimes = action.val;
      return {
        ...state,
      };
    }
    case "UPDATE_UPSELLS": {
      state.upsells = action.val;
      return {
        ...state,
      };
    }
    case "IMPORT_TICKETS": {
      state.event.tickets = action.tickets;
      return {
        ...state,
      };
    }
    case "ADD_DISCOUNTCODE": {
      return {
        ...state,
        discountCode: action.value,
      };
    }
    case "REMOVE_DISCOUNTCODE": {
      return {
        ...state,
        discountCode: "",
      };
    }
    case "UPDATE_DATE": {
      state.event.date = action.date;
      state.date = moment(action.date).format("dddd D MMMM YYYY");
      return {
        ...state,
      };
    }
    case "UPDATE_TIME": {
      state.event.time = action.time;
      return {
        ...state,
      };
    }
    case "UPDATE_DATES": {
      state.dates = action.dates;
      return {
        ...state,
      };
    }

    case "UPDATE_SAMEAS": {
      // action.value
      // action.index
      return {
        ...state,
      };
    }

    case "UPDATE_TERMS": {
      // action.value
      // action.index
      state.terms = action.value;
      return {
        ...state,
      };
    }

    case "UPDATE_PERFORMANCE": {
      state.event.perfID = action.val;
      return {
        ...state,
      };
    }
    case "ADD_MEMBERSHIP": {
      return {
        ...state,
        membershipOffer: true,
        ticketType: "Membership",
      };
    }
    case "ADD_TICKET": {
      const ticketID = action.id;
      const ticketInfo = state.event.tickets.find((x) => x.id === ticketID);
      const currentEventTicketIndex = state.event.tickets.findIndex((x) => x.type === ticketInfo!.name);

      state.totalTickets = state.totalTickets + 1;
      //state.totalFee = state.totalFee + ticketInfo!.price;
      state.event.totalTickets = state.event.totalTickets + 1;
      state.event.tickets[currentEventTicketIndex].num = state.event.tickets[currentEventTicketIndex].num + 1;
      return {
        ...state,
      };
    }
    case "REMOVE_TICKET": {
      const ticketID = action.id;
      const ticketInfo = state.event.tickets.find((x) => x.id === ticketID);
      const currentEventTicketIndex = state.event.tickets.findIndex((x) => x.type === ticketInfo!.name);

      state.totalTickets = state.totalTickets - 1;
      //state.totalFee = state.totalFee - ticketInfo!.price;
      state.event.totalTickets = state.event.totalTickets - 1;
      state.event.tickets[currentEventTicketIndex].num = state.event.tickets[currentEventTicketIndex].num - 1;

      return {
        ...state,
      };
    }
    case "UPDATE_PEOPLELISTAK": {
      state.peopleAK = action.peopleAKList;
      return {
        ...state,
      };
    }
    case "UPDATE_SALEAK": {
      state.saleak = action.saleak;
      return {
        ...state,
      };
    }
    case "UPDATE_PEOPLELIST": {
      const list = action.list;

      state.contactDetails = {
        title: list.title,
        first_name: list.first_name,
        last_name: list.last_name,
        email: list.email,
        mobile_number: list.mobile_number,
        membership_number: list.membership_number,
        postcode: list.postcode,
        country: list.country,
        enews: list.enews,
      };

      state.people = list.visitors;

      return {
        ...state,
      };
    }
    default:
      return state;
  }
};

function initStore(preloadedState = initialState) {
  return createStore(reducer, preloadedState, composeWithDevTools(applyMiddleware(thunkMiddleware)));
}

export const initializeStore = (preloadedState?) => {
  let _store = store ?? initStore(preloadedState);
  if (preloadedState && store) {
    _store = initStore({
      ...store.getState(),
      ...preloadedState,
    });
    store = undefined;
  }
  if (typeof window === "undefined") return _store;
  if (!store) store = _store;

  return _store;
};

export function useStore(initialState) {
  const store = useMemo(() => initializeStore(initialState), [initialState]);
  return store;
}
